import http from '@/utils/http'

export function getAnswerResults(params){
    return  http('/adminAnswerResults',{params})
}

export function getAnswerResultsDetail(id){
    return  http(`/adminAnswerResults/${id}`)
}